module.exports = __webpack_public_path__ + "static/media/oh_pack3_sample006_0001.db82563c.png";